export default __webpack_public_path__ + "static/media/me.92c8f369.jpg";